import { Person } from '../beans/Person';
import { BlockUiService } from '../services/blockui.service';
import { PersonService } from '../services/person.service';
import { Component, OnInit, ViewContainerRef, HostListener } from '@angular/core';

@Component({
	selector: 'app-person',
	templateUrl: './person.component.html',
	styleUrls: ['./person.component.scss']
})
export class PersonComponent implements OnInit {
	searchString: string;
	personList: Array<Person>;

	public personColumns = [
		{ title: 'Име', name: 'name' },
		{ title: 'Юридическо Лице', name: 'legalEntity', dataType: 'boolean' },
		{ title: 'Булстат/ЕГН', name: 'egn' },
		{ title: 'Адрес', name: 'address' },
		{ title: 'Телефон', name: 'phone' },
		{ title: 'Имейл', name: 'email' }
	];
	constructor(private blockUi: BlockUiService, private vcRef: ViewContainerRef, private personService: PersonService) { }

	ngOnInit() {
		this.personList = new Array<Person>();
		this.loadTable();
	}
	
	loadTable() {
		this.blockUi.start(this.vcRef);
		this.personList = new Array<Person>();
		this.personService.getPersons().subscribe(
			result => {
				this.personList = result;
				this.blockUi.stop();
			},
			error => {
				this.blockUi.stop();
			}
		);
	}

	public expanderClicked(event: any) {

	}
	searchPerson() {
		this.blockUi.start(this.vcRef);
		this.personList = new Array<Person>();
		this.personService.searchPersons(this.searchString).subscribe(result => {
			this.personList = result;
			this.blockUi.stop();
		},
			error => {
				this.blockUi.stop();
			});
	}

	@HostListener('document:keydown', ['$event'])
	handleKeyboardEvent(event: KeyboardEvent) {

		// 👉 Ctrl + Enter -> Търси
		if (event.ctrlKey && event.key === 'Enter') {
			event.preventDefault();
			this.searchPerson();        // твоя метод за търсене
		}
	}
}
